import React, { useEffect } from 'react'
import { Grid, IconButton, Typography, withStyles } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Icon from '@mdi/react'
import { mdiMessageQuestion } from '@mdi/js'

import styles from '../../../resources/theme/global'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { downloadImportTemplate, fetchClients } from '../ClientActions'
import { getClientListData } from '../ClientReducer'
import Filter from './Filter'
import List from './List'

const Clients = props => {
  const dispatch = useDispatch()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead, canUpdate } = usePermissions()

  const { classes } = props

  useEffect(() => {
    dispatch(fetchClients(filters?.page || 1, filters, filters?.rows || 10))
  }, [location])

  return (
    <Grid
      container
      className={classes.pageHead}
      spacing={1}
      alignItems="center"
    >
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px' }}
          color={colors.primary}
        >
          Clientes
          <IconButton className={classes.questionBox}>
            <a href="" target="_blank" rel="noreferrer">
              <Icon
                path={mdiMessageQuestion}
                size={1}
                color={colors.secondary}
                style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                }}
              />
            </a>
          </IconButton>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Filter classes={classes} />
      </Grid>

      {canRead('clientes', permissionUser) && (
        <Grid item xs={12}>
          <List classes={classes} items={[]} />
        </Grid>
      )}

      {canCreate('clientes', permissionUser) && (
        <Link to="/clients/new" />
      )}
      {canUpdate('clientes', permissionUser) && (
        <Link to="/clients/:id/edit" />
      )}
    </Grid>
  )
}

export default withStyles(styles)(Clients)
